var map = {
	"./": [
		"8hXn",
		0,
		1
	],
	"./about_us": [
		"4Utp",
		5
	],
	"./about_us.vue": [
		"4Utp",
		5
	],
	"./about_xqs": [
		"yWau",
		0,
		3
	],
	"./about_xqs.vue": [
		"yWau",
		0,
		3
	],
	"./award": [
		"jFxw",
		0,
		12
	],
	"./award.vue": [
		"jFxw",
		0,
		12
	],
	"./award/create": [
		"VLcY",
		0,
		15
	],
	"./award/create.vue": [
		"VLcY",
		0,
		15
	],
	"./award/creativity": [
		"yjOX",
		0,
		11
	],
	"./award/creativity.vue": [
		"yjOX",
		0,
		11
	],
	"./award/creativity_备份": [
		"VpdY",
		0,
		10
	],
	"./award/creativity_备份.vue": [
		"VpdY",
		0,
		10
	],
	"./award/education": [
		"ccpV",
		0,
		17
	],
	"./award/education.vue": [
		"ccpV",
		0,
		17
	],
	"./award_type": [
		"1i9q",
		0,
		9
	],
	"./award_type.vue": [
		"1i9q",
		0,
		9
	],
	"./brand": [
		"S7L6",
		2
	],
	"./brand.vue": [
		"S7L6",
		2
	],
	"./education": [
		"8dhT",
		0,
		8
	],
	"./education.vue": [
		"8dhT",
		0,
		8
	],
	"./index": [
		"8hXn",
		0,
		1
	],
	"./index.vue": [
		"8hXn",
		0,
		1
	],
	"./info": [
		"iNA+",
		16
	],
	"./info.vue": [
		"iNA+",
		16
	],
	"./news": [
		"uxuc",
		0,
		7
	],
	"./news.vue": [
		"uxuc",
		0,
		7
	],
	"./news_details": [
		"Tc3u",
		0,
		18
	],
	"./news_details.vue": [
		"Tc3u",
		0,
		18
	],
	"./order": [
		"vF69",
		0,
		4
	],
	"./order.vue": [
		"vF69",
		0,
		4
	],
	"./order_beifen": [
		"9Nbz",
		0,
		13
	],
	"./order_beifen.vue": [
		"9Nbz",
		0,
		13
	],
	"./order_type": [
		"DXh8",
		0,
		6
	],
	"./order_type.vue": [
		"DXh8",
		0,
		6
	],
	"./product": [
		"pGxt",
		14
	],
	"./product.vue": [
		"pGxt",
		14
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "MWF8";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/views lazy ^\.\/.*$
// module id = MWF8
// module chunks = 21